module.exports = __webpack_public_path__ + "img/Node.a1b2c4fd.png";